<template>
  <div class="autocomplete-maps">
    <input type="text" id="deliver" name="deliver" placeholder="START TYPING YOUR ADDRESS" v-model="localLoc">
    <ul class="autocomplete-items">
      <li class="prediction" v-for="(result, i) in searchResults" :key="i" @click="setValue(result)">
        {{ result.description }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    found: {
      type: Function
    },
    location: {
      type: String
    }
  },
  name: 'ProfilePlaces',
  data: () => ({
    searchResults: [],
    service: null, // will reveal this later 🕵️,
    search_break: false,
    no_change: true,
    selectedPlace: null,
    localLoc: ''
  }),
  watch: {
    localLoc (newValue) {
      if (this.no_change) {
        this.no_change = false
      } else {
        if (newValue && !this.search_break) {
          this.service.getPlacePredictions({
            input: this.localLoc,
            fields: ['address_components', 'geometry'],
            types: ['address']
          }, this.displaySuggestions)
        }
        if (newValue === '') {
          this.searchResults = []
        }
      }
    }
  },
  methods: {
    setValue (value) {
      this.searchResults = []
      this.search_break = true
      setTimeout(() => {
        this.search_break = false
      }, 3000)
      this.localLoc = value.structured_formatting.main_text
      this.found(value, value.structured_formatting.main_text)
    },
    MapsInit () {
      this.service = new window.google.maps.places.AutocompleteService()
    },
    displaySuggestions (predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.map(prediction => prediction)

    }
  },
  mounted () {
    this.MapsInit()
    this.localLoc = this.location
  }
}
</script>

<style lang="scss">
.deliver-to {
  padding: 10px;
}
.autocomplete-maps {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;
  width:100%;
  input {
    width:100%;
    text-align: left;
    &::placeholder{
    font-weight: 900;
    }
  }

  .autocomplete-items {
    position: absolute;
    border: 1px solid #d4d4d4;
    border-bottom: none;
    border-top: none;
    z-index: 99;
    /*position the autocomplete items to be the same width as the container:*/
    top: calc(100% - 5px);
    left: 0;
    right: 0;
    background: white;
  }
  .autocomplete-items li {
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #c3c3c3;
  }
  .autocomplete-items li:hover {
    /*when hovering an item:*/
    background-color: #e9e9e9;
  }
  .autocomplete-active {
    /*when navigating through the items using the arrow keys:*/
    background-color: DodgerBlue !important;
    color: #ffffff;
  }
}
.mobile {
  .traddress {
    .vx-col {
      padding: 0;
    }
  }
}
</style>
